exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".system--debug{background-color:coral;z-index:9999999999;position:fixed;top:0;width:200px;height:300px}", ""]);

// exports
